<template>
  <div
    class="block-text"
    tabindex="0"
  >
    <div class="info-row">
      <div class="info-row-label">
        <p>
          {{ $i18n.t('MANAGE.SUBSCRIBER_DATA.TARIFF') }}
          <strong>{{ tariffName }}</strong>
        </p>
      </div>
      <div class="info-row-value">
        <p>
          {{ tariffPrice }}
        </p>
      </div>
    </div>
    <div class="info-row">
      <div class="info-row-label">
        <p>
          {{ $i18n.t('MANAGE.SUBSCRIBER_DATA.EXPIRATION_DATE') }}
        </p>
      </div>
      <div class="info-row-value">
        <p>
          <strong>{{ tariffExpirationDate }}</strong>
        </p>
      </div>
    </div>
    <br>
    <!-- eslint-disable -->
    <p v-html="tariffDescription" />
    <p v-html="tariffLegalText" />
    <!-- eslint-enable -->
  </div>
</template>

<script>

export default {
  name: 'BlockTextTariff',
  props: {
    tariffName: {
      type: String,
      required: true,
    },
    tariffPrice: {
      type: String,
      required: true,
    },
    tariffExpirationDate: {
      type: String,
      required: true,
    },
    tariffDescription: {
      type: String,
      required: true,
    },
    tariffLegalText: {
      type: String,
      required: true,
    },
  },
};

</script>

<style lang="scss" src="@/components/block-text/block-text.scss">
</style>